/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100070 得意先納入マスタメンテ
 */
import {
  SText,
  SCodeSelect,
  SFrame,
  SLabel,
  SNumberField,
  STextField,
  SFileButton,
  msgState,
  SNormalButton,
  STable,
  SEntryTab,
  SCancelButton,
  SConfirmDialog,
  SConfirmDialogAction,
} from "components";
import {
  B100070HyojunnonyuKbn,
  getSCode,
  HyojunnonyuKbn,
  SCode,
} from "messages/codes";
import { labels } from "messages/labels";
import { createRef, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { focusState, navigateTypeState, useFocus } from "states";
import { useNavigate } from "react-router-dom";
import { Column } from "@material-table/core";
import { B000150 } from "pages/b000/B000150";
import { B000151 } from "pages";
import { calledParam, hyojunnonyuKbn } from "services/codes";
import { B000150TokuiNm1, B000151TokuiNm1, catchRestError } from "clients/rest";
import {
  B100070Create,
  B100070CreateRequest,
  B100070CreateTokuinonyuList,
  B100070Delete,
  B100070DeleteRequest,
  B100070Find,
  B100070FindRequest,
  B100070Update,
  B100070UpdateRequest,
  B100070UpdateTokuinonyuList,
} from "clients/rest/b100/B100070";
import { getClientError, getClientMessage } from "messages";
import { mapIds } from "services";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
// ヘッダ部
type Fields = Partial<{
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
}>;

// 明細入力部
type MeiFields = Partial<{
  tab: boolean;
  tokuiCd: string;
  tokuishitenCd: string;
  defaultNonyuCd: string;
  defaultNonyushitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  tokuiNm1: string;
  hyojunnonyuKbn: SCode;
  version: number;
}>;

//テーブルデータの定義
type Data = Partial<{
  gyoNo: number;
  tokuiCd: string;
  tokuishitenCd: string;
  defaultNonyuCd: string;
  defaultNonyushitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  tokuiNm1: string;
  hyojunnonyuKbn: string;
  hyojunnonyuKbnF: string;
  version: number;
}>;

// フィールドの初期値を設定する。
// ヘッダ部
const defaultFields: Fields = {
  tokuiCd: "",
  tokuishitenCd: "",
  tokuiNm: "",
};

// 明細入力部
const defaultMeiFields: MeiFields = {
  tab: true,
  tokuiCd: "",
  tokuishitenCd: "",
  defaultNonyuCd: "",
  defaultNonyushitenCd: "",
  nonyuCd: "",
  nonyushitenCd: "",
  tokuiNm1: "",
  hyojunnonyuKbn: getSCode(HyojunnonyuKbn, "0"),
  version: undefined,
};

const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "3rem", align: "right" },
  { field: "tokuiCd", hidden: true },
  { field: "tokuishitenCd", hidden: true },
  { field: "defaultNonyuCd", hidden: true },
  { field: "defaultNonyushitenCd", hidden: true },
  { field: "nonyuCd", title: "納入先コード", width: "5rem" },
  { field: "nonyushitenCd", width: "4rem" },
  { field: "tokuiNm1", title: "納入先名", width: "30rem" },
  { field: "hyojunnonyuKbn", hidden: true },
  { field: "hyojunnonyuKbnF", title: "標準区分", width: "5rem" },
  { field: "version", hidden: true },
];

const focusId = "B100070";

// B100070 得意先納入マスタメンテ
export const B100070 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  const meiMethods = useForm<MeiFields>({
    mode: "onBlur",
    defaultValues: defaultMeiFields,
  });

  // テーブル管理
  const tableRef = createRef();
  const [rows, setRows] = useState<Data[]>([]);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移
  const navigate = useNavigate();
  // 更新確認ダイアログオープン用
  const [openUpdateConfirm, setOpenUpdateConfirm] = useState(false);
  // 削除確認ダイアログオープン用
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  // 画面遷移の処理
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);

  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 検索フォームのデータを取得する。
    const fields = methods.getValues();

    // タブ部に得意先コードをセット
    meiMethods.setValue("tokuiCd", methods.watch("tokuiCd"));
    meiMethods.setValue("tokuishitenCd", methods.watch("tokuishitenCd"));

    // 検索パラメータを作成する。
    const param: B100070FindRequest = {
      tokuiCd: fields.tokuiCd!,
      tokuishitenCd: fields.tokuishitenCd!,
    };

    // API呼び出し
    B100070Find(param)
      // 正常取得時
      .then((value) => {
        // グリッドへのマッピング
        const gridDataList = value.data.map<Data>((value, index) => {
          // 行番号
          const gyoNo: number = index + 1;
          // 行のデータセット
          const data: Data = {
            gyoNo: Number(gyoNo),
            tokuiCd: value.tokuiCd,
            tokuishitenCd: value.tokuishitenCd,
            defaultNonyuCd: value.nonyuCd,
            defaultNonyushitenCd: value.nonyushitenCd,
            nonyuCd: value.nonyuCd,
            nonyushitenCd: value.nonyushitenCd,
            tokuiNm1: value.tokuiNm1,
            hyojunnonyuKbn: value.hyojunnonyuKbn,
            hyojunnonyuKbnF: getSCode(
              B100070HyojunnonyuKbn,
              value.hyojunnonyuKbn
            )?.label,
            version: value.version,
          };
          return data;
        });
        // テーブルに反映
        setRows(gridDataList);
      })
      // エラー時
      .catch((reason) => {
        setRows([]);
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 登録
  const handleCreate = () => {
    // タブ部のデータ取得
    const meiFields = meiMethods.getValues();

    // 新規登録するデータの作成
    const newData: B100070CreateTokuinonyuList = {
      tokuiCd: meiFields.tokuiCd!,
      tokuishitenCd: meiFields.tokuishitenCd!,
      nonyuCd: meiFields.nonyuCd!,
      nonyushitenCd: meiFields.nonyushitenCd!,
      hyojunnonyuKbn: meiFields.hyojunnonyuKbn?.value!,
    };

    // 標準納入先区分が「1:標準」のデータを取得する。
    const hyojunDataRow = rows.filter(function (source: Data) {
      return Number(source.hyojunnonyuKbn) === Number(hyojunnonyuKbn.hyojun);
    });

    // APIリクエストの準備
    let param: B100070CreateRequest;

    // 明細部の標準納入先区分が「1:標準」かつ標準納入先区分が「1:標準」のデータが存在する場合
    if (
      meiFields.hyojunnonyuKbn?.value === hyojunnonyuKbn.hyojun &&
      hyojunDataRow.length > 0
    ) {
      // 標準納入先区分が元々「1:標準」だったものを「0:非標準」にしたデータの作成
      const hyojunData: B100070CreateTokuinonyuList = {
        tokuiCd: hyojunDataRow[0].tokuiCd!,
        tokuishitenCd: hyojunDataRow[0].tokuishitenCd!,
        nonyuCd: hyojunDataRow[0].nonyuCd!,
        nonyushitenCd: hyojunDataRow[0].nonyushitenCd!,
        hyojunnonyuKbn: hyojunnonyuKbn.notHyojun,
        version: hyojunDataRow[0].version!,
      };

      // 新規登録リクエストに、新規登録するデータと標準納入先区分を「0:非標準」にしたデータをセットする。
      param = {
        b100070CreateFieldList: [newData, hyojunData],
      };
    }
    // 上記条件に当てはまらない場合
    else {
      // 新規登録するデータのみを新規登録リクエストにセットする。
      param = {
        b100070CreateFieldList: [newData],
      };
    }

    B100070Create(param)
      .then(() => {
        // 更新した行がある場合
        if (
          meiFields.hyojunnonyuKbn?.value === hyojunnonyuKbn.hyojun &&
          hyojunDataRow.length > 0
        ) {
          // 更新した行のデータ更新
          changeToNothyojunRow(hyojunDataRow[0]);
        }
        // 新規登録したデータの行追加
        addRow(newData);
        // タブ部の各項目を初期化する
        meiMethods.reset();
        meiMethods.setValue("tokuiCd", newData.tokuiCd);
        meiMethods.setValue("tokuishitenCd", newData.tokuishitenCd);
        // 登録完了メッセージ表示
        setMsg(getClientMessage("B100070_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 更新確認ダイアログ表示
  const handleOpenUpdateConfirm = () => {
    const meiFields = meiMethods.getValues();
    if (
      meiFields.hyojunnonyuKbn!.value === hyojunnonyuKbn.notHyojun &&
      rowData?.hyojunnonyuKbn!.toString() === hyojunnonyuKbn.hyojun
    ) {
      setMsg(getClientError("B100070_001"));
      return;
    } else {
      setOpenUpdateConfirm(true);
    }
  };

  // 削除確認ダイアログキャンセル
  const handleCancelUpdateConfirm = () => {
    setOpenUpdateConfirm(false);
  };

  // 更新
  const handleUpdate = () => {
    setOpenUpdateConfirm(false);
    const meiFields = meiMethods.getValues();

    // 更新データ作成
    const updateData: B100070UpdateTokuinonyuList = {
      tokuiCd: meiFields.tokuiCd!,
      tokuishitenCd: meiFields.tokuishitenCd!,
      defaultNonyuCd: meiFields.defaultNonyuCd!,
      defaultNonyushitenCd: meiFields.defaultNonyushitenCd!,
      nonyuCd: meiFields.nonyuCd!,
      nonyushitenCd: meiFields.nonyushitenCd!,
      hyojunnonyuKbn: meiFields.hyojunnonyuKbn!.value,
      version: meiFields.version!,
    };

    // 標準納入先区分が「1:標準」のデータを取得する。
    const hyojunDataRow = rows
      .filter(function (source: Data) {
        return Number(source.hyojunnonyuKbn) === Number(hyojunnonyuKbn.hyojun);
      })
      // 選択行は除く
      .filter(function (source: Data) {
        return source.gyoNo !== rowData?.gyoNo;
      });

    // APIリクエストの準備
    let param: B100070UpdateRequest;

    // 明細部の標準納入先区分が「1:標準」かつ標準納入先区分が「1:標準」のデータが存在する場合
    if (
      meiFields.hyojunnonyuKbn?.value === hyojunnonyuKbn.hyojun &&
      hyojunDataRow.length > 0
    ) {
      // 標準納入先区分が元々「1:標準」だったものを「0:非標準」にしたデータの作成
      const hyojunData: B100070UpdateTokuinonyuList = {
        tokuiCd: hyojunDataRow[0].tokuiCd!,
        tokuishitenCd: hyojunDataRow[0].tokuishitenCd!,
        defaultNonyuCd: hyojunDataRow[0].defaultNonyuCd!,
        defaultNonyushitenCd: hyojunDataRow[0].defaultNonyushitenCd!,
        nonyuCd: hyojunDataRow[0].nonyuCd!,
        nonyushitenCd: hyojunDataRow[0].nonyushitenCd!,
        hyojunnonyuKbn: hyojunnonyuKbn.notHyojun,
        version: hyojunDataRow[0].version!,
      };

      // 新規登録リクエストに、新規登録するデータと標準納入先区分を「0:非標準」にしたデータをセットする。
      param = {
        b100070UpdateFieldList: [updateData, hyojunData],
      };
    }
    // 上記条件に当てはまらない場合
    else {
      // 新規登録するデータのみを新規登録リクエストにセットする。
      param = {
        b100070UpdateFieldList: [updateData],
      };
    }

    B100070Update(param)
      .then(() => {
        // 更新した行の表示更新
        updateRow(rowData, meiFields, hyojunDataRow[0]);
        // タブ部の初期化
        meiMethods.reset();
        meiMethods.setValue("tokuiCd", updateData.tokuiCd);
        meiMethods.setValue("tokuishitenCd", updateData.tokuishitenCd);
        // 更新完了メッセージ表示
        setMsg(getClientMessage("B100070_002"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 削除確認ダイアログ表示
  const handleOpenDeleteConfirm = () => {
    if (rowData?.hyojunnonyuKbn!.toString() === hyojunnonyuKbn.hyojun) {
      setMsg(getClientError("B100070_002"));
      return;
    } else {
      setOpenDeleteConfirm(true);
    }
  };

  // 削除確認ダイアログキャンセル
  const handleCancelDeleteConfirm = () => {
    setOpenDeleteConfirm(false);
  };

  // 削除
  const handleDelete = () => {
    setOpenDeleteConfirm(false);

    const meiFields = meiMethods.getValues();

    const param: B100070DeleteRequest = {
      tokuiCd: meiFields.tokuiCd!,
      tokuishitenCd: meiFields.tokuishitenCd!,
      nonyuCd: meiFields.defaultNonyuCd!,
      nonyushitenCd: meiFields.defaultNonyushitenCd!,
      version: meiFields.version!,
    };

    B100070Delete(param)
      .then(() => {
        // 選択行の削除処理
        // 選択行の行番号取得
        const gyoNo = rowData?.gyoNo;
        // 取得した行番号の行を除いた全てのデータを取得
        const newRows = rows.filter(function (source: Data) {
          return source.gyoNo !== gyoNo;
        });
        // 明細テーブルの行番号振り直し
        mapIds(newRows, "gyoNo");
        // 削除後のデータセット
        setRows(newRows);
        // 明細入力部の初期化
        meiMethods.reset();
        meiMethods.setValue("tokuiCd", param.tokuiCd);
        meiMethods.setValue("tokuishitenCd", param.tokuishitenCd);
        // タブを新規にする
        meiMethods.setValue("tab", true);
        // 削除完了メッセージを表示する。
        setMsg(getClientMessage("B100070_003"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (rowData: Data) => {
    meiMethods.reset();
    // タブを編集にする
    meiMethods.setValue("tab", false);
    // ダブルクリックした行を選択状態にする
    setRowData(rowData);
    // 明細入力部にデータを表示する。
    meiMethods.setValue("tokuiCd", rowData.tokuiCd);
    meiMethods.setValue("tokuishitenCd", rowData.tokuishitenCd);
    meiMethods.setValue("defaultNonyuCd", rowData.defaultNonyuCd);
    meiMethods.setValue("defaultNonyushitenCd", rowData.defaultNonyushitenCd);
    meiMethods.setValue("nonyuCd", rowData.nonyuCd);
    meiMethods.setValue("nonyushitenCd", rowData.nonyushitenCd);
    meiMethods.setValue("tokuiNm1", rowData.tokuiNm1);
    meiMethods.setValue(
      "hyojunnonyuKbn",
      getSCode(HyojunnonyuKbn, rowData.hyojunnonyuKbn!)
    );
    meiMethods.setValue("version", rowData.version);
  };

  // タブ切り替え
  const handleChangeTab = () => {
    // 行選択解除
    setRowData(undefined);
    // 明細入力部の値を初期化
    meiMethods.reset();
    // 得意先コードをセット
    meiMethods.setValue("tokuiCd", rows[0].tokuiCd);
    meiMethods.setValue("tokuishitenCd", rows[0].tokuishitenCd);
  };

  // 新規登録行の追加
  const addRow = (newData: B100070CreateTokuinonyuList) => {
    const gyoNo: number = rows.length + 1;
    const newRowData: Data = {
      gyoNo: gyoNo,
      tokuiCd: newData.tokuiCd,
      tokuishitenCd: newData.tokuishitenCd,
      defaultNonyuCd: newData.nonyuCd,
      defaultNonyushitenCd: newData.nonyushitenCd,
      nonyuCd: newData.nonyuCd,
      nonyushitenCd: newData.nonyushitenCd,
      tokuiNm1: meiMethods.watch("tokuiNm1"),
      hyojunnonyuKbn: newData.hyojunnonyuKbn,
      hyojunnonyuKbnF: getSCode(B100070HyojunnonyuKbn, newData.hyojunnonyuKbn)
        ?.label,
      version: 0,
    };

    setRows([...rows, newRowData]);
  };

  // 標準から非標準になった行の更新
  const changeToNothyojunRow = (hyojunDataRow: Data) => {
    const gyoNo: number = hyojunDataRow.gyoNo!;
    const changedRowData: Data = {
      gyoNo: gyoNo,
      tokuiCd: hyojunDataRow.tokuiCd,
      tokuishitenCd: hyojunDataRow.tokuishitenCd,
      defaultNonyuCd: hyojunDataRow.defaultNonyuCd,
      defaultNonyushitenCd: hyojunDataRow.defaultNonyushitenCd,
      nonyuCd: hyojunDataRow.nonyuCd,
      nonyushitenCd: hyojunDataRow.nonyushitenCd,
      tokuiNm1: hyojunDataRow.tokuiNm1,
      hyojunnonyuKbn: hyojunnonyuKbn.notHyojun,
      hyojunnonyuKbnF: getSCode(B100070HyojunnonyuKbn, hyojunnonyuKbn.notHyojun)
        ?.label,
      version: hyojunDataRow.version! + 1,
    };

    // 明細を設定
    rows[gyoNo - 1] = changedRowData;
    setRows([...rows]);
  };

  // 行の更新
  const updateRow = (
    rowData: any,
    meiFields: MeiFields,
    hyojunDataRow: Data
  ) => {
    // 明細入力部の反映
    const gyoNo: number = rowData.gyoNo!;
    const changedRowData: Data = {
      gyoNo: gyoNo,
      tokuiCd: meiFields.tokuiCd,
      tokuishitenCd: meiFields.tokuishitenCd,
      defaultNonyuCd: meiFields.nonyuCd,
      defaultNonyushitenCd: meiFields.nonyushitenCd,
      nonyuCd: meiFields.nonyuCd,
      nonyushitenCd: meiFields.nonyushitenCd,
      tokuiNm1: meiFields.tokuiNm1,
      hyojunnonyuKbn: meiFields.hyojunnonyuKbn!.value,
      hyojunnonyuKbnF: getSCode(
        B100070HyojunnonyuKbn,
        meiFields.hyojunnonyuKbn!.value
      )?.label,
      version: meiFields.version! + 1,
    };

    // 明細を設定
    rows[gyoNo - 1] = changedRowData;

    // 標準納入先区分を更新した行がある場合
    if (
      meiFields.hyojunnonyuKbn?.value === hyojunnonyuKbn.hyojun &&
      hyojunDataRow
    ) {
      // 標準納入先区分を非標準に変更する行の取得
      const hyojunGyoNo: number = hyojunDataRow.gyoNo!;
      const hyojunRowData: Data = {
        gyoNo: hyojunGyoNo,
        tokuiCd: hyojunDataRow.tokuiCd,
        tokuishitenCd: hyojunDataRow.tokuishitenCd,
        defaultNonyuCd: hyojunDataRow.defaultNonyuCd,
        defaultNonyushitenCd: hyojunDataRow.defaultNonyushitenCd,
        nonyuCd: hyojunDataRow.nonyuCd,
        nonyushitenCd: hyojunDataRow.nonyushitenCd,
        tokuiNm1: hyojunDataRow.tokuiNm1,
        hyojunnonyuKbn: hyojunnonyuKbn.notHyojun,
        hyojunnonyuKbnF: getSCode(
          B100070HyojunnonyuKbn,
          hyojunnonyuKbn.notHyojun
        )?.label,
        version: hyojunDataRow.version! + 1,
      };

      // 明細を設定
      rows[hyojunGyoNo - 1] = hyojunRowData;
    }

    setRows([...rows]);
  };

  // excelボタンクリック時
  const handleMoveOutput = () => {
    // 得意先納入先マスタ出力画面へ遷移する。
    setMenuNavigate("next");
    navigate("/b100073");
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="得意先納入マスタメンテ"
          gridTemplateColumns="7rem 6rem 5rem 15rem 4rem 3rem 8rem 7rem 7rem"
        >
          <SText gridColumn="span 8"></SText>
          <SFileButton
            label={labels.buttons.excel}
            align="right"
            {...register(3)}
            onClick={handleMoveOutput}
          />
          <SLabel required gridColumn="1">
            得意先コード
          </SLabel>
          <SNumberField
            name="tokuiCd"
            label="得意先コード"
            code
            required
            size={6}
            {...register(1)}
          />
          <SNumberField
            name="tokuishitenCd"
            label="得意先支店コード"
            code
            required
            size={4}
            dialog={<B000150 calledParam={calledParam.tokui} />}
            handleSubmit={(data: any) => {
              methods.setValue("tokuiCd", data.tokuiCd);
              methods.setValue("tokuishitenCd", data.tokuishitenCd);
              methods.setValue("tokuiNm", data.tokuiNm1);
            }}
            onBlur={() => B000150TokuiNm1(methods, navigate, setMsg)}
            {...register(2)}
          />
          <STextField name="tokuiNm" disabled />
          <SText></SText>
          <SNormalButton
            onClick={handleClickSearchButton}
            label={labels.buttons.search}
            align="right"
            {...register(5)}
          />
        </SFrame>
      </FormProvider>

      <SFrame>
        <STable
          keyName="gyoNo"
          data={rows}
          columns={columns}
          tableRef={tableRef}
          handleDoubleClick={handleDoubleClickTableRow}
          width={800}
          height={430}
          pageSize={15}
        />
      </SFrame>

      <FormProvider {...meiMethods}>
        <SFrame>
          <SEntryTab name="tab" handleOk={handleChangeTab}></SEntryTab>
          <SFrame gridTemplateColumns="6rem 5rem 15rem 6rem">
            <SLabel gridColumn="span 2">納入先コード</SLabel>
            <SLabel>納入先名</SLabel>
            <SLabel>標準区分</SLabel>

            <SNumberField
              name="nonyuCd"
              label="納入先コード"
              code
              size={6}
              {...register(6)}
            />
            <SNumberField
              name="nonyushitenCd"
              label="納入支店コード"
              code
              size={4}
              dialog={<B000151 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("nonyuCd", data.nonyuCd);
                meiMethods.setValue("nonyushitenCd", data.nonyushitenCd);
                meiMethods.setValue("tokuiNm1", data.tokuiNm1);
              }}
              onBlur={() => B000151TokuiNm1(meiMethods, navigate, setMsg)}
              {...register(7)}
            />
            <STextField name="tokuiNm1" disabled />
            <SCodeSelect
              name="hyojunnonyuKbn"
              options={HyojunnonyuKbn}
              {...register(8)}
            />

            {meiMethods.getValues().tab === true ? (
              <>
                <SNormalButton
                  label={labels.buttons.create}
                  gridRow="3"
                  gridColumn="4"
                  align="right"
                  {...register(9)}
                  dialog={
                    <SConfirmDialog
                      title={labels.dialog.createMasterTitle}
                      msg={labels.dialog.createConfirm}
                    />
                  }
                  dialogAction="confirm"
                  handleSubmit={handleCreate}
                />
              </>
            ) : (
              <>
                <SCancelButton
                  label={labels.buttons.linedeletion}
                  gridRow="3"
                  align="left"
                  {...register(10)}
                  onClick={handleOpenDeleteConfirm}
                />
                <SNormalButton
                  label={labels.buttons.update}
                  gridRow="3"
                  gridColumn="4"
                  align="right"
                  {...register(11)}
                  onClick={handleOpenUpdateConfirm}
                />
              </>
            )}
          </SFrame>
        </SFrame>
        <SConfirmDialogAction
          title={labels.dialog.updateMasterTitle}
          msg={labels.dialog.updateConfirm}
          onOk={handleUpdate}
          onCancel={handleCancelUpdateConfirm}
          isOpen={openUpdateConfirm}
        />
        <SConfirmDialogAction
          title={labels.dialog.deleteMasterTitle}
          msg={labels.dialog.deleteConfirm}
          onOk={handleDelete}
          onCancel={handleCancelDeleteConfirm}
          isOpen={openDeleteConfirm}
        />
      </FormProvider>
    </>
  );
};
